import { createFileRoute } from '@tanstack/react-router';
import { ReceiptsRegister } from '../../../features/purchasing-intake/ReceiptsRegister';

/** Owned by G20. Goods receipts + weighbridge tickets registers, with
 * Reverse & clone on POSTED docs (plan.md QC fix #10). */
export const Route = createFileRoute('/_authenticated/purchasing-intake/receipts')({
  component: ReceiptsRegister,
});
